export class Storage {

  static getString(key: string): string | null {
    return localStorage.getItem(key);
  }

  static getNumber(key: string): number | null {
    const item = localStorage.getItem(key);
    if (item === null) return null;
    try {
      return Number(item);
    } catch (e) {
      return null;
    }
  }

  static getJSON(key: string): object | null {
    const item = localStorage.getItem(key);
    if (item === null) return null;
    try {
      return JSON.parse(item);
    } catch (e) {
      return null;
    }
  }

  static getArray(key: string): any[] | null {
    const item = localStorage.getItem(key);
    if (item === null) return null;
    try {
      return JSON.parse(item) as any[];
    } catch (e) {
      return null;
    }
  }

  static setString(key: string, str: string) {
    localStorage.setItem(key, str);
  }

  static setNumber(key: string, number: string) {
    localStorage.setItem(key, number.toString());
  }

  static setJSON(key: string, json: object) {
    localStorage.setItem(key, JSON.stringify(json));
  }

  static setArray(key: string, json: any[]) {
    localStorage.setItem(key, JSON.stringify(json));
  }

  static remove(key: string) {
    localStorage.removeItem(key);
  }

  static clear() {
    localStorage.clear();
  }
}
